export default __webpack_public_path__ + "static/media/33.04e078dd.webp";